export default "__VITE_ASSET__52c03f6f__"